import axios from "axios";

import { getConstansApiRoute } from "../apiRoutes";

export async function getServerConstants() {
  return await axios
    .get(getConstansApiRoute)
    .then(res => res)
    .catch(err => err.response);
}
